import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=c05796bc&scoped=true"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05796bc",
  null
  
)

export default component.exports